import React from "react";
import { HiOutlineXMark } from "react-icons/hi2";
import { useOnboarding } from "../../hooks";
import { OnboardingSteps } from "./onboarding-steps";
import "./onboarding-card.scss";

export const OnboardingCard = (): JSX.Element | null => {
  const { steps, completed, total, allDone, ready, dismissed, dismiss } =
    useOnboarding();

  // Hide until extension detection resolves, when fully set up, or once dismissed
  if (!ready || allDone || dismissed) return null;

  return (
    <div className="onboarding-card">
      <button
        className="onboarding-card__close"
        onClick={dismiss}
        aria-label="Dismiss setup guide"
      >
        <HiOutlineXMark size={20} />
      </button>

      <OnboardingSteps steps={steps} completed={completed} total={total} />
    </div>
  );
};

export default OnboardingCard;
